export default __webpack_public_path__ + "static/media/ipet03.ccc5a632.png";